import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMovePage = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 38.056 40.901",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Flytt_side",
		"data-name": "Flytt side",
		transform: "translate(4572.091 23066.582)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "edit_document_FILL0_wght300_GRAD0_opsz48",
			d: "M182.69,231.425A2.719,2.719,0,0,1,180,228.736V198.69A2.719,2.719,0,0,1,182.69,196h15.489l9.788,9.788v6.949h-2.115v-5.55h-9.071v-9.071H182.69a.617.617,0,0,0-.574.574v30.046a.617.617,0,0,0,.574.574h11.975v2.115Zm-.574-2.115v0Z",
			transform: "translate(-4752.092 -23262.582)"
		}), /* @__PURE__ */ _jsx("path", {
			id: "export_notes_FILL0_wght300_GRAD0_opsz48",
			d: "M285.351-667.27l5.272-5.272v4.428h1.345v-6.724h-6.724v1.345h4.447L284.4-668.22Zm3.083,4.163a7.836,7.836,0,0,1-5.784-2.422,7.9,7.9,0,0,1-2.394-5.745,7.956,7.956,0,0,1,2.394-5.839,7.9,7.9,0,0,1,5.809-2.4,7.9,7.9,0,0,1,5.775,2.4,7.93,7.93,0,0,1,2.409,5.839,7.871,7.871,0,0,1-2.409,5.745A7.885,7.885,0,0,1,288.434-663.107Z",
			transform: "translate(-5224.281 -22766.551) rotate(45)"
		})]
	})
});
export default SvgMovePage;
